import { loggedUserRequestErrorHandler } from '../shared/http/error';
import { USER_TYPES } from '../pages/Admin/shared/static-options';
import DynamicAPI from '../shared/axios';
import { performanceStatus } from '../pages/Tracking/utils/delivery-status';

// ======================
// Actions
// ======================
const GET_DELIVERY_STATUS_DELIVERIES_LIST =
  'luft/delivery-status/GET_DELIVERY_STATUS_DELIVERIES_LIST';
const GET_DELIVERY_STATUS_DELIVERIES_LIST_SUCCESS =
  'luft/delivery-status/GET_DELIVERY_STATUS_DELIVERIES_LIST_SUCCESS';
const GET_DELIVERY_STATUS_DELIVERIES_LIST_FAILURE =
  'luft/delivery-status/GET_DELIVERY_STATUS_DELIVERIES_LIST_FAILURE';
const CHANGE_DELIVERY_STATUS =
  'luft/delivery-status/CHANGE_DELIVERY_STATUS';

// ==========================
// MAPS
// ==========================
export const deliveryStatusTypes = {
  PRIME: 'prime',
  NORMAL: 'normal',
  ALL: 'all',
};

export const storeKeys = {
  PERIOD_SELECTION: 'periodSelection',
  REAL_TIME: 'realTime',
};

// ======================
// Initial State
// ======================
const initialState = {
  [storeKeys.PERIOD_SELECTION]: {
    isFetching: false,
    error: '',
    deliveries: [],
  },
  [storeKeys.REAL_TIME]: {
    isFetching: false,
    error: '',
    deliveries: [],
  },
  performanceStatusSelected: [
    performanceStatus.ONTIME,
    performanceStatus.LATE_RISK,
    performanceStatus.LATE
  ]
};

// ======================
// REDUCER
// ======================
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_DELIVERY_STATUS_DELIVERIES_LIST: {
      return {
        ...state,
        [action.storeKey]: {
          ...state[action.storeKey],
          isFetching: true,
          error: '',
        },
      };
    }

    case GET_DELIVERY_STATUS_DELIVERIES_LIST_SUCCESS: {
      return {
        ...state,
        [action.storeKey]: {
          ...state[action.storeKey],
          isFetching: false,
          deliveries: action.data,
        },
      };
    }

    case GET_DELIVERY_STATUS_DELIVERIES_LIST_FAILURE: {
      return {
        ...state,
        [action.storeKey]: {
          ...state[action.storeKey],
          isFetching: false,
          error: action.error,
        },
      };
    }
    
    case CHANGE_DELIVERY_STATUS: {
      return {
        ...state,
        [action.storeKey]: {
          ...state[action.storeKey],
          isFetching: false,
          error: action.error,
        },
      };
    }

    default: {
      return state;
    }
  }
}

// ======================
// ACTION CREATORS
// ======================
function _getDeliveryStatusDeliveriesList(storeKey) {
  return {
    type: GET_DELIVERY_STATUS_DELIVERIES_LIST,
    storeKey,
  };
}

function _getDeliveryStatusDeliveriesListSuccess(data, storeKey) {
  return {
    type: GET_DELIVERY_STATUS_DELIVERIES_LIST_SUCCESS,
    data,
    storeKey,
  };
}

function _getDeliveryStatusDeliveriesListFailure(error, storeKey) {
  return {
    type: GET_DELIVERY_STATUS_DELIVERIES_LIST_FAILURE,
    error,
    storeKey,
  };
}

// ======================
// THUNKS
// ======================
export function getDeliveryStatusDeliveriesList(
  usePeriodSelecionDates = false,
  storeKey,
  notPassCompanyId,
) {
  return async function (dispatch, getState) {
    dispatch(_getDeliveryStatusDeliveriesList(storeKey));

    // extract params from state
    const {
      selectedPeriodInitialDate,
      selectedPeriodFinalDate,
      initialPeriod,
      finalPeriod,
      listCompany,
      shippingGroupId,
      listCustomers,
      listUf,
      listRegion,
      keyAccount,
      carrierCnpj,
      carrierList,
      byDate
    } = getState().dashboardFilters.filters;
    const { activeCompanyId, userType } = getState().auth;

    const _expectedActiveCompanyId = () => {
      if (notPassCompanyId) {
        return null;
      }

      if (userType === USER_TYPES.CUSTOMER_SERVICE_USER) {
        return activeCompanyId;
      }

      return null;
    };

    const params = {
      initialPeriod: usePeriodSelecionDates
        ? selectedPeriodInitialDate
        : initialPeriod,
      finalPeriod: usePeriodSelecionDates
        ? selectedPeriodFinalDate
        : finalPeriod,
      listCompany,
      customerId: listCustomers,
      listUf,
      listRegion,
      keyAccount,
      shippingGroupId,
      listStatus: [7],
      byDate,
      page: 1,
      amount: 1000,
      companyId: _expectedActiveCompanyId(),
      carrierCnpj: carrierCnpj || carrierList,
    };

    try {
      const http = new DynamicAPI('v5');
      const response = await http.get(
        '/IntegratedTracking/GetIntegratedTrackingList',
        params,
      );
      response.data = response.data.map(res => {
        if (res.tms.plate) res.tms.plate = res.tms.plate.trim();
        return res;
      });

      dispatch(
        _getDeliveryStatusDeliveriesListSuccess(response.data, storeKey),
      );

      return response.data;
    } catch (error) {
      loggedUserRequestErrorHandler(
        dispatch,
        error,
        _getDeliveryStatusDeliveriesListFailure(error.message, storeKey),
      );
      throw new Error(error.message);
    }
  };
}

export function changeDeliveryStatus(status = []) {
  return {
    type: CHANGE_DELIVERY_STATUS,
    status,
  };
}
